/**
 * Countries Utilities
 * Handles loading and processing countries configuration
 */

/**
 * Load countries configuration from public JSON file
 * @returns {Promise<Array>} Array of enabled countries with phone codes and flags
 */
export const loadCountriesConfig = async () => {
  try {
    const response = await fetch('/countries-config.json');
    if (!response.ok) {
      throw new Error('Failed to load countries configuration');
    }
    
    const config = await response.json();
    
    // Return only enabled countries, formatted for phone code dropdown
    return config.supportedCountries
      .filter(country => country.enabled)
      .map(country => ({
        code: country.phoneCode,
        country: country.name,
        flag: country.flag,
        isoCode: country.code,
        alpha3Code: country.alpha3Code
      }));
  } catch (error) {
    console.error('Error loading countries configuration:', error);
    
    // Fallback to South Africa if config fails to load
    return [{
      code: '+27',
      country: 'South Africa', 
      flag: '🇿🇦',
      isoCode: 'ZA',
      alpha3Code: 'ZAF'
    }];
  }
};

/**
 * Get default country from configuration
 * @param {Array} countries - Array of countries from config
 * @returns {Object} Default country object
 */
export const getDefaultCountry = (countries) => {
  // Look for South Africa (default in config)
  const defaultCountry = countries.find(country => country.isoCode === 'ZA');
  
  // Fall back to first country if South Africa not found
  return defaultCountry || countries[0] || {
    code: '+27',
    country: 'South Africa',
    flag: '🇿🇦',
    isoCode: 'ZA'
  };
};
